<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>AG Charts Enterprise</h1>
					<p waBody="m" waText>Advanced chart types &mdash; gauges, heatmaps, polar charts, hierarchical visualisations, and financial instruments extending the community AG Charts plugin. Includes radial/linear gauges, candlestick, OHLC, waterfall, treemap, sunburst, sankey, and chord diagrams.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">AG Charts Enterprise 13.1.0</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						<wa-tag pill variant="warning">License Required</wa-tag>
					</div>
					<p waBody="s" waColorText="warning" waText>AG Charts Enterprise requires a commercial license. 30-day evaluation available from ag-grid.com/license-pricing/</p>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:agcharts-enterprise</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.plugins.agchartsenterprise</p>
					<p waBody="s" waText>Built on: AG Charts Enterprise 13.1.0</p>
				</div>
				<wa-details summary="Installation">
					<div class="wa-stack wa-gap-xs">
						@if (!useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
								<markdown [data]="mdContent_495" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
						@if (useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
								<markdown [data]="mdContent_496" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
					</div>
				</wa-details>
				<wa-details summary="NPM Dependencies (auto-included)">
					<markdown [data]="mdContent_497" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<h2 waHeading="l" waText>Components &#40;17&#41;</h2>
					<p waBody="m" waText>Click any component to see its full API &mdash; properties, constructors, methods, events, slots, and examples.</p>
					<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>AgCandlestickSeriesOptions</h4>
								<p waBody="s" waColorText="quiet" waText>Financial candlestick series with open/high/low/close keys</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">5 props</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/agcharts-enterprise/ag-candlestick-series-options']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>AgWaterfallSeriesOptions</h4>
								<p waBody="s" waColorText="quiet" waText>Waterfall chart series showing cumulative values</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">2 props</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/agcharts-enterprise/ag-waterfall-series-options']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>AgTreemapSeriesOptions</h4>
								<p waBody="s" waColorText="quiet" waText>Hierarchical treemap series</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">2 props</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/agcharts-enterprise/ag-treemap-series-options']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>AgSunburstSeriesOptions</h4>
								<p waBody="s" waColorText="quiet" waText>Radial hierarchical sunburst series</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">2 props</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/agcharts-enterprise/ag-sunburst-series-options']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>AgSankeySeriesOptions</h4>
								<p waBody="s" waColorText="quiet" waText>Flow/sankey diagram series</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">2 props</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/agcharts-enterprise/ag-sankey-series-options']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>AgRangeBarSeriesOptions</h4>
								<p waBody="s" waColorText="quiet" waText>Range bar series with min/max values</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">3 props</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/agcharts-enterprise/ag-range-bar-series-options']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>AgRangeAreaSeriesOptions</h4>
								<p waBody="s" waColorText="quiet" waText>Range area series with min/max values</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">3 props</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/agcharts-enterprise/ag-range-area-series-options']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>AgRadialColumnSeriesOptions</h4>
								<p waBody="s" waColorText="quiet" waText>Radial/polar column series</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">2 props</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/agcharts-enterprise/ag-radial-column-series-options']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>AgRadialBarSeriesOptions</h4>
								<p waBody="s" waColorText="quiet" waText>Radial/polar bar series</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">2 props</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/agcharts-enterprise/ag-radial-bar-series-options']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>AgRadarLineSeriesOptions</h4>
								<p waBody="s" waColorText="quiet" waText>Radar/spider line series</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">2 props</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/agcharts-enterprise/ag-radar-line-series-options']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>AgRadarAreaSeriesOptions</h4>
								<p waBody="s" waColorText="quiet" waText>Radar/spider area series</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">2 props</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/agcharts-enterprise/ag-radar-area-series-options']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>AgNightingaleSeriesOptions</h4>
								<p waBody="s" waColorText="quiet" waText>Nightingale/rose chart series</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">2 props</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/agcharts-enterprise/ag-nightingale-series-options']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>AgHistogramSeriesOptions</h4>
								<p waBody="s" waColorText="quiet" waText>Histogram series with automatic binning</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">1 props</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/agcharts-enterprise/ag-histogram-series-options']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>AgHeatmapSeriesOptions</h4>
								<p waBody="s" waColorText="quiet" waText>Heatmap matrix series</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">3 props</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/agcharts-enterprise/ag-heatmap-series-options']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>AgFunnelSeriesOptions</h4>
								<p waBody="s" waColorText="quiet" waText>Funnel chart series</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">2 props</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/agcharts-enterprise/ag-funnel-series-options']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>AgChordSeriesOptions</h4>
								<p waBody="s" waColorText="quiet" waText>Chord diagram series</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">2 props</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/agcharts-enterprise/ag-chord-series-options']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>AgOhlcSeriesOptions</h4>
								<p waBody="s" waColorText="quiet" waText>OHLC &#40;Open-High-Low-Close&#41; financial series</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">5 props</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/agcharts-enterprise/ag-ohlc-series-options']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
					</div>
				</div>
				<wa-details summary="Features (9)">
					<div class="wa-stack wa-gap-xs">
						<p waBody="s" waColorText="quiet" waText>Financial charts &mdash; Candlestick, OHLC, Waterfall, Box Plot, Histogram</p>
						<p waBody="s" waColorText="quiet" waText>Gauges &mdash; Radial and Linear gauges with segmentation, targets, and scales</p>
						<p waBody="s" waColorText="quiet" waText>Polar charts &mdash; Radial Column, Radial Bar, Nightingale, Radar &#40;Line and Area&#41;</p>
						<p waBody="s" waColorText="quiet" waText>Heatmaps &mdash; color-coded grid visualizations with gradient scales</p>
						<p waBody="s" waColorText="quiet" waText>Hierarchical charts &mdash; Treemap, Sunburst, Sankey, Chord</p>
						<p waBody="s" waColorText="quiet" waText>Specialized visualizations &mdash; Funnel charts, Range Area, Range Bar</p>
						<p waBody="s" waColorText="quiet" waText>CRTP fluent builders for all enterprise chart options</p>
						<p waBody="s" waColorText="quiet" waText>Advanced styling &mdash; custom colors, gradients, fills, and patterns</p>
						<p waBody="s" waColorText="quiet" waText>Interactive features &mdash; tooltips, legends, zoom, pan, highlighting</p>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Examples (2)">
					<div class="wa-stack wa-gap-m">
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Radial Gauge</h4>
							<p waBody="s" waColorText="quiet" waText>Create a radial gauge with min/max scale.</p>
							<markdown [data]="mdContent_498" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Candlestick Chart</h4>
							<p waBody="s" waColorText="quiet" waText>Create a financial candlestick chart.</p>
							<markdown [data]="mdContent_499" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="Quick Start">
					<markdown [data]="mdContent_500" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="SPI Extension Point Details (1)">
					<div class="wa-stack wa-gap-s">
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">IPageConfigurator</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>AgChartsEnterprisePageConfigurator auto-registers ag-charts-enterprise module and license key</p>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="SPI Extension Points">
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
						</div>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Properties (1)">
					<table style="border-collapse:collapse;width:100%;">
						<thead>
							<tr style="border-bottom:2px solid var(--wa-color-neutral-200);">
								<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Property</th>
								<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Type</th>
								<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Default</th>
								<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Description</th>
							</tr>
						</thead>
						<tbody>
							<tr style="border-bottom:1px solid var(--wa-color-neutral-100);">
								<td style="color:var(--wa-color-brand-normal);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);">AG_CHARTS_LICENSE_KEY</td>
								<td style="color:var(--wa-color-text-quiet);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);padding:var(--wa-spacing-small);">String</td>
								<td style="color:var(--wa-color-text-quiet);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);padding:var(--wa-spacing-small);">–</td>
								<td style="font-size:var(--wa-font-size-s);padding:var(--wa-spacing-small);">AG Charts Enterprise license key — set via AgChartsEnterprisePageConfigurator.setAG_CHARTS_LICENSE_KEY()</td>
							</tr>
						</tbody>
					</table>
				</wa-details>
				<wa-details open summary="Prerequisites">
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://charts.ag-grid.com/javascript/license/</wa-tag>
					<wa-tag pill variant="neutral">Docs: https://charts.ag-grid.com/javascript/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/AgChartsEnterprise</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>